// src/js/config/sendOrder.js

import { DOMElements } from './dom.js';
import { showMessage } from './ui/showMessage.js';
import { getLoadedPackageConfig } from './orderState.js';

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function collectOrderFormData() {
    const getValue = (el) => el ? el.value.trim() : '';

    return {
        packageConfiguration: JSON.stringify(getLoadedPackageConfig()),
        company: getValue(DOMElements.company),
        corpId: getValue(DOMElements.corpId),
        address: getValue(DOMElements.address),
        zipCode: getValue(DOMElements.zipCode),
        city: getValue(DOMElements.city),
        name: getValue(DOMElements.name),
        customerEmail: getValue(DOMElements.customerEmail),
        phoneNo: getValue(DOMElements.phoneNo),
        invoiceEmail: getValue(DOMElements.invoiceEmail),
        poNumber: getValue(DOMElements.poNumber),
        invoiceReference: getValue(DOMElements.invoiceReference),
        order_language: document.documentElement.lang.slice(0, 2)
    };
}

export async function handleSendOrderClick() {
    const strings = window.SimP_Strings || {};
    const packageConfig = getLoadedPackageConfig();

    if (!packageConfig) {
        showMessage(strings.send_order_config_missing || 'Ingen produktkonfiguration har laddats.', 'error');
        return;
    }

    if (!DOMElements.termsCheckbox || !DOMElements.termsCheckbox.checked) {
        showMessage(strings.send_order_error_terms || 'Du måste godkänna köpvillkoren.', 'error');
        return;
    }

    const orderData = collectOrderFormData();

    const requiredFields = [
        orderData.company,
        orderData.corpId,
        orderData.address,
        orderData.zipCode,
        orderData.city,
        orderData.name,
        orderData.customerEmail,
        orderData.phoneNo,
        orderData.invoiceEmail
    ];

    // Kontrollerar om något av de obligatoriska fälten är tomt
    if (requiredFields.some(field => field === '')) {
        showMessage(strings.send_order_error_required_fields || 'Vänligen fyll i alla obligatoriska fält.', 'error');
        return;
    }

    // Separat kontroll för giltigt e-postformat
    if (!isValidEmail(orderData.customerEmail) || !isValidEmail(orderData.invoiceEmail)) {
        showMessage(strings.send_order_email_error || 'Vänligen ange en giltig e-postadress i båda e-postfälten.', 'error');
        return;
    }

    try {
        showMessage(strings.send_order_info_sending || 'Skickar din beställning...', 'info');

        // Hämta reCAPTCHA v3-token (osynligt, ingen interaktion)
        let recaptchaToken = '';
        const siteKey = window.orderFormData.recaptchaSiteKey;
        if (siteKey && window.grecaptcha) {
            try {
                recaptchaToken = await window.grecaptcha.execute(siteKey, { action: 'submit_order' });
            } catch (e) {
                // Graceful degradation: om reCAPTCHA misslyckas, skicka ändå
            }
        }

        const response = await fetch(window.orderFormData.restApiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...orderData, recaptcha_token: recaptchaToken }),
        });

        const result = await response.json();

        if (response.ok) {
            showMessage(result.message || strings.send_order_info_sent || 'Beställning skickad!', 'success');
            const redirectUrl = new URL(window.orderFormData.pendingVerificationPageUrl);
            redirectUrl.searchParams.set('order_id', result.order_id);
            window.location.href = redirectUrl.toString();
        } else {
            throw new Error(result.message || 'Ett oväntat fel uppstod.');
        }

    } catch (error) {
        console.error('Fel vid insändning av order:', error);
        showMessage((strings.send_order_error_sending || 'Kunde inte skicka beställningen: ') + error.message, 'error');
    }
}